<template>
  <div class="text-editor-layout">
    <!-- <v-row align="center" justify="center">
      <v-col cols="auto" class="mt-5 pl-10 pr-10">
        <span id="text-editor-title" class="ml-1">Add Text Clip</span>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto" class="mt-5 mr-5">
        <v-btn dark elevation="0" icon @click="$emit('discardPreview')">
          <span class="material-icons-round" style="font-size: 24px !important">close</span>
        </v-btn>
      </v-col>
    </v-row> -->

    <v-row align="center" justify="center" no-gutters>
      <v-col class="">
        <div class="input-div">
          <bubble-menu class="bubble-menu" :tippy-options="{ duration: 100 }" :editor="editor" v-if="editor">
            <button
              @click="editor.chain().focus().toggleBold().run()"
              :class="{ 'is-active': editor.isActive('bold') }"
            >
              <i class="ri-bold"></i>
            </button>
            <button
              @click="editor.chain().focus().toggleItalic().run()"
              :class="{ 'is-active': editor.isActive('italic') }"
            >
              <i class="ri-italic"></i>
            </button>
            <button
              @click="editor.chain().focus().toggleUnderline().run()"
              :class="{ 'is-active': editor.isActive('underline') }"
            >
              <i class="ri-underline"></i>
            </button>
            <button
              @click="editor.chain().focus().toggleStrike().run()"
              :class="{ 'is-active': editor.isActive('strike') }"
            >
              <i class="ri-strikethrough"></i>
            </button>
            <button @click="editor.isActive('link') ? unsetLink() : openDialog()">
              <i v-if="editor.isActive('link')" class="ri-link-unlink"></i>
              <i v-else class="ri-link"></i>
            </button>
            <button class="bubble-button-color">
              <input type="color" @input="editor.chain().focus().setColor($event.target.value).run()" />
            </button>
          </bubble-menu>
          <!-- <floating-menu :editor="editor" :tippy-options="{ duration: 100 }" v-if="editor">
            <button
              @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
              :class="{ 'is-active': editor.isActive('heading', { level: 1 }) }"
            >
              H1
            </button>
            <button
              @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
              :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }"
            >
              H2
            </button>
            <button
              @click="editor.chain().focus().toggleBulletList().run()"
              :class="{ 'is-active': editor.isActive('bulletList') }"
            >
              Bullet List
            </button>
            <button @click="editor.chain().focus().setHorizontalRule().run()">horizontal rule</button>
          </floating-menu> -->
          <editor-content :editor="editor" @keydown.space.native="spaceHack" />
        </div>
      </v-col>
    </v-row>
    <!-- 타이틀 -->
    <!-- <v-row align="center" justify="center">
      <v-col class="mt-1 pl-10 pr-10 pb-0 mb-0">
        <v-text-field
          label="Enter title (optional)"
          :placeholder="$t('enterTitle')"
          v-model="clipTitle"
          dark
          solo
          background-color="#1a272e"
        ></v-text-field>
      </v-col>
    </v-row> -->
    <!-- <v-row no-gutters class="px-7 pb-4" justify="center" align="center">
      <v-col cols="6" align="start">
        <v-col cols="6" align="start" class="row-thumbnail" style="color: #eee; font-weight: 700">
          {{ 'Notification' }}
        </v-col>
        <v-col cols="6" align="start" class="row-thumbnail">
          <notification-dialog
            @customRecipientList="customRecipientList"
            @chkboxWs="chkboxWs"
            @chkboxPostComment="chkboxPostComment"
          ></notification-dialog>
        </v-col>
      </v-col>
      <v-col cols="6" align="end">
        <v-col cols="6" class="row-thumbnail" align="center" justify="right" no-gutters>
          <v-btn block color="#96a7af" width="100" @click="$emit('discardPreview')" class="btn-discard">
            {{ $t('discard') }}
          </v-btn>
        </v-col>
        <v-col cols="6" class="row-thumbnail ml-4" align="center" no-gutters>
          <v-btn
            color="rgb(40, 144, 103)"
            width="100"
            block
            :disabled="textClip === null || textClip === '' || textClip === '<p></p>'"
            :loading="isTextUploadLoading"
            @click="uploadText"
            class="btn-post"
          >
            {{ $t('post') }}
          </v-btn>
        </v-col>
      </v-col>
    </v-row> -->
    <v-dialog v-model="setLinkDialog.show" width="500">
      <v-card style="background-color: #21343b; padding: 30px; border-radius: 10px">
        <v-text-field
          dark
          class="add-url-input"
          placeholder="https://..."
          type="input"
          v-model="setLinkDialog.url"
          @keydown.enter="(e) => setLink(e.target.value)"
          solo
          background-color="#1a272e"
        ></v-text-field>
        <v-btn color="rgb(40, 144, 103)" width="100" block @click="setLink(setLinkDialog.url)" style="color: #eee">
          {{ 'Add Link' }}
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight'
import { Editor, EditorContent, BubbleMenu, VueNodeViewRenderer } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import javascript from 'highlight.js/lib/languages/javascript'
import html from 'highlight.js/lib/languages/xml'
import css from 'highlight.js/lib/languages/css'
import python from 'highlight.js/lib/languages/python'
import sql from 'highlight.js/lib/languages/sql'
import typescript from 'highlight.js/lib/languages/typescript'
import csharp from 'highlight.js/lib/languages/csharp'
import bash from 'highlight.js/lib/languages/bash'
import shell from 'highlight.js/lib/languages/shell'
import java from 'highlight.js/lib/languages/java'
import cpp from 'highlight.js/lib/languages/cpp'
import c from 'highlight.js/lib/languages/c'
import CodeBlockComponent from '../meeting/component/template/CodeBlockComponent.vue'
import { lowlight } from 'lowlight'
lowlight.registerLanguage('Javascript', javascript)
lowlight.registerLanguage('HTML', html)
lowlight.registerLanguage('CSS', css)
lowlight.registerLanguage('Python', python)
lowlight.registerLanguage('SQL', sql)
lowlight.registerLanguage('Java', java)
lowlight.registerLanguage('Typescript', typescript)
lowlight.registerLanguage('C#', csharp)
lowlight.registerLanguage('Bash', bash)
lowlight.registerLanguage('Shell', shell)
lowlight.registerLanguage('C++', cpp)
lowlight.registerLanguage('C', c)
import Commands from '../meeting/component/template/commands'
import suggestion from '../meeting/component/template/suggestion'
import { Color } from '@tiptap/extension-color'
import Underline from '@tiptap/extension-underline'
import TextStyle from '@tiptap/extension-text-style'
import Placeholder from '@tiptap/extension-placeholder'
import Link from '@tiptap/extension-link'
// import NotificationDialog from '@/views/modal/NotificationDialog'

export default {
  name: 'texteditorDialog',
  components: {
    EditorContent,
    BubbleMenu,
    // NotificationDialog,
  },
  props: {
    recordType: String,
    blob: {
      type: null,
      required: true,
    },
    duration: Number,
  },
  data() {
    return {
      clipTitle: '',
      note: '',
      poster: '',
      blobUrl: null,
      blobData: null,
      rules: {
        required: (value) => !!value || 'Required.',
        calendly: (value) => {
          const pattern = /^http[s]?:\/\/calendly.com\/([\S]{1,})\/([\S]{1,})/g
          if (value.length > 0) {
            if (pattern.test(value)) {
              return (this.valid = true)
            } else {
              this.valid = false
              return 'Please check the URL you entered'
            }
          } else {
            this.valid = false
            return true
          }
        },
      },
      valid: false,
      editor: null,
      editorble: null,
      textClip: '',
      setLinkDialog: { url: '', show: false },
      isTextUploadLoading: false,
    }
  },
  mounted() {
    if (this.blob && this.blob !== null) {
      this.blobUrl = URL.createObjectURL(this.blob)
    }
    this.editor = new Editor({
      content: '',
      editable: true,
      autofocus: 'end',
      parseOptions: {
        preserveWhitespace: 'full',
      },
      extensions: [
        StarterKit,
        Color.configure({
          types: ['textStyle'],
        }),
        Placeholder.configure({
          emptyEditorClass: 'is-editor-empty',
          placeholder: 'Type "/" for commands',
        }),
        Underline,
        TextStyle,
        Commands.configure({
          suggestion,
        }),
        CodeBlockLowlight.extend({
          addNodeView() {
            return VueNodeViewRenderer(CodeBlockComponent)
          },
        }).configure({ lowlight }),
        Link.configure({
          // openOnClick: true,
          // autolink: true,
        }),
      ],
      onUpdate: () => {
        // HTML
        // this.$emit('input', this.editor.getHTML())
        this.textClip = this.editor.getHTML()
        // JSON
        // this.$emit('input', this.editor.getJSON())
      },
    })
  },
  beforeDestroy() {
    if (this.blobUrl !== null) {
      URL.revokeObjectURL(this.blobUrl)
      this.blobUrl = null
    }
    // this.editor.destroy()
  },
  methods: {
    customRecipientList(val) {
      this.$emit('customRecipientList', val)
    },
    chkboxPostComment(val) {
      this.$emit('chkboxPostComment', val)
    },
    chkboxWs(val) {
      this.$emit('chkboxWs', val)
    },
    // 스페이스바가 안 먹는 기현상을 해결하기 위한 핵
    spaceHack(e) {
      e.stopPropagation()
    },
    openDialog() {
      let existingURL = this.editor.getAttributes('link').href
      if (existingURL) {
        this.setLinkDialog.url = existingURL
      }
      this.setLinkDialog.show = true
    },
    setLink(url) {
      // empty
      if (url === '') {
        this.editor.chain().focus().extendMarkRange('link').unsetLink().run()
      } else {
        // update link
        this.editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run()
      }
      this.setLinkDialog.show = false
      this.setLinkDialog.url = ''
    },
    unsetLink() {
      this.editor.chain().focus().unsetLink().run()
    },
    onEditorChange() {
      this.textClip = this.$refs.toastUiEditor.invoke('getHTML')
    },
    uploadText() {
      this.editor.commands.enter()
      this.isTextUploadLoading = true
      this.$emit('templateUpload', this.textClip)
    },
  },
  computed: {
    mtInfo() {
      return this.$store.getters.currentMt
    },
    currentClip() {
      return this.$store.getters.currentClip
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
    content() {
      return this.$store.getters.currentClip.textClip
    },
  },
  watch: {
    note() {
      this.$emit('clipNote', this.note)
    },
    clipTitle(val) {
      this.$emit('clipTitle', val)
    },
    textClip() {
      // this.textClip = val.replace(/\n/g, '').replace(/\r/g, '')
      this.$emit('textClip', this.textClip)
    },
    content(value) {
      // HTML
      const isSame = this.editor.getHTML() === value
      // JSON
      // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)
      if (isSame) {
        return
      }
      this.editor.commands.setContent(value, false)
      this.textClip = this.editor.getHTML()
    },
  },
}
</script>

<style>
.ProseMirror blockquote {
  padding-left: 1rem;
  margin-left: 1rem;
  border-left: 3px solid rgba(230, 230, 230, 0.1);
}
/* Placeholder */
.ProseMirror p::before {
  content: attr(data-placeholder);
  float: left;
  color: #646c74;
  pointer-events: none;
  height: 0;
}
@import url('https://cdn.jsdelivr.net/npm/remixicon@2.5.0/fonts/remixicon.css');
</style>

<style scoped>
.text-editor-layout {
  position: relative;
  /* min-width: 360px; */
  width: 100%;
  height: 100%;
  /* max-width: 500px; */
  background-color: #21343b;
}
span {
  color: white;
  font-weight: bold;
}
#text-editor-title {
  font-size: 20px;
}
#note {
  font-size: 14px;
}
#text-length {
  font-size: 14px;
  display: inline-block;
  width: 100%;
  text-align: right;
  transform: translate(-20px, -30px);
  font-weight: normal;
  color: #869399;
}
.share-text-div {
  background: #1a272e;
  width: 100%;
  height: 200px;
  display: inline-block;
  vertical-align: middle;
}
.el-textarea >>> .el-textarea__inner {
  background: #1a272e;
  border-color: transparent;
  color: white;
}
.add-url-input >>> .v-input__slot {
  background: #1a272e;
  color: white;
  border-radius: 10px !important;
}
.el-input >>> .el-input__inner {
  background: #1a272e;
  border-color: transparent;
  color: white;
}
.input-div {
  width: 100%;
  height: 100%;
}
@media (max-width: 1263px) {
  .input-div {
    width: 100%;
    height: 100%;
  }
}
.row-thumbnail >>> .v-btn * {
  font-size: 14px;
  letter-spacing: 0;
  text-transform: none;
  color: white;
  font-weight: bold;
}
.input-div div {
  width: 100%;
  height: 100% !important;
  padding: 20px;
  background-color: #161d21;
  color: #eee;
  overflow: auto;
  line-height: 140%;
}
.input-div >>> div:focus-visible {
  outline: none !important;
}
.tippy-box {
  background-color: transparent;
  padding: 0 !important;
}

.tippy-content {
  background-color: transparent;
  width: 100%;
  padding: 0 !important;
}

.tippy-content div {
  background-color: transparent;
  width: 100%;
  padding: 0 !important;
}

.tippy-content div button {
  background-color: #eee;
  border: 1px solid #eee;
  padding: 4px 5px 0px 5px;
}
.tippy-content div button i {
  font-size: 18px;
}
.tippy-content div button span {
  color: #232b2f;
  font-weight: normal;
  /* transition: all 0.3s; */
}
.tippy-content div button:hover {
  border: 1px solid #289067;
  background-color: #289067;
  color: #eee !important;
  opacity: 1;
}
.tippy-content div button:hover span {
  color: #eee !important;
}
.tippy-content div button.is-active {
  border: 1px solid #289067;
  background-color: #289067;
  opacity: 1;
}
.tippy-content div button.is-active i {
  color: #eee !important;
}

.ProseMirror > * + * {
  margin-top: 0.75em;
}
.ProseMirror pre {
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  font-family: 'JetBrainsMono', monospace;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
}
.ProseMirror pre code {
  color: inherit;
  padding: 0;
  background: none;
  font-size: 0.8rem;
}
.ProseMirror pre .hljs-comment,
.ProseMirror pre .hljs-quote {
  color: #616161;
}
.ProseMirror pre .hljs-variable,
.ProseMirror pre .hljs-template-variable,
.ProseMirror pre .hljs-attribute,
.ProseMirror pre .hljs-tag,
.ProseMirror pre .hljs-name,
.ProseMirror pre .hljs-regexp,
.ProseMirror pre .hljs-link,
.ProseMirror pre .hljs-name,
.ProseMirror pre .hljs-selector-id,
.ProseMirror pre .hljs-selector-class {
  color: #f98181;
}
.ProseMirror pre .hljs-number,
.ProseMirror pre .hljs-meta,
.ProseMirror pre .hljs-built_in,
.ProseMirror pre .hljs-builtin-name,
.ProseMirror pre .hljs-literal,
.ProseMirror pre .hljs-type,
.ProseMirror pre .hljs-params {
  color: #fbbc88;
}
.ProseMirror pre .hljs-string,
.ProseMirror pre .hljs-symbol,
.ProseMirror pre .hljs-bullet {
  color: #b9f18d;
}
.ProseMirror pre .hljs-title,
.ProseMirror pre .hljs-section {
  color: #faf594;
}
.ProseMirror pre .hljs-keyword,
.ProseMirror pre .hljs-selector-tag {
  color: #70cff8;
}
.ProseMirror pre .hljs-emphasis {
  font-style: italic;
}
.ProseMirror pre .hljs-strong {
  font-weight: 700;
}
.code-block select {
  color: #161d21;
  background-color: #eee;
  border-radius: 3px;
  padding: 2px 4px;
  font-size: 14px;
  letter-spacing: -0.5px;
}
.bubble-menu {
  overflow: hidden !important;
}
.bubble-button-color {
  position: relative;
  padding: 0 2px !important;
}
.bubble-button-color input {
  padding: 0 !important;
  width: 27px;
  height: 28px;
  cursor: pointer;
}
.row-thumbnail {
  display: inline-block;
  max-width: 300px;
}
.btn-discard >>> span {
  color: #31434f !important;
}
</style>
